import { Helmet } from 'react-helmet-async'
import HomeTemplate from '../templates/HomeTemplate.jsx'
import DownloaderSEO from '../components/ui/DownloaderSEO.jsx'
import { PAGES, buildFAQSchema, buildHowToSchema } from '../utils/seo.js'
import { useLanguage } from '../context/LanguageContext.jsx'

const { title, description, canonical } = PAGES.youtube

const faqSchema = buildFAQSchema([
  { q: 'Can I download YouTube videos as both MP3 and MP4?', a: 'Yes! FastAudio lets you download any YouTube video as MP3 audio (128, 192, or 320kbps) or as MP4 video (480p, 720p HD, or 1080p Full HD) — all formats are shown after you paste the URL.' },
  { q: 'Can I download YouTube Shorts?', a: 'Yes! YouTube Shorts are fully supported. Paste the Shorts URL (youtube.com/shorts/...) and choose MP3 or MP4 format.' },
  { q: 'What is the best quality for YouTube to MP3?', a: 'Choose 320kbps for music — it\'s the highest quality. For podcasts or spoken word, 128kbps is fine and produces a smaller file.' },
  { q: 'Is FastAudio completely free?', a: 'Yes, 100% free with no registration, no limits, and no hidden charges.' },
  { q: 'Does it work on mobile?', a: 'Yes — FastAudio works in all modern mobile browsers on iPhone and Android. No app needed.' },
])

const howToSchema = buildHowToSchema('How to Download YouTube to MP3 or MP4', [
  { title: 'Copy the YouTube URL', text: 'Copy the video URL from your browser or the YouTube app.' },
  { title: 'Paste into FastAudio', text: 'Paste the URL into the search box — the video info loads automatically.' },
  { title: 'Choose MP3 or MP4', text: 'Select your format: MP3 audio (128/192/320kbps) or MP4 video (480p/720p/1080p).' },
  { title: 'Click Download', text: 'Hit the ⚡ Download button next to your chosen format.' },
  { title: 'Save your file', text: 'Click Save when ready — the file downloads directly to your device.' },
])

export default function YouTubeDownloader() {
  const { t } = useLanguage()
  return (
    <>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
        <script type="application/ld+json">{JSON.stringify(howToSchema)}</script>
      </Helmet>
      <HomeTemplate
        provider="youtube"
        title={title}
        description={description}
        canonical={canonical}
        badge={t('youtubeBadge')}
        heading={
          <>
            {t('youtubeH1')}{' '}
            <span className="text-gradient">{t('youtubeH2')}</span>
          </>
        }
        subheading={t('youtubeSub')}
        placeholder={t('ytPlaceholder')}
      >
        <DownloaderSEO provider="youtube" />
      </HomeTemplate>
    </>
  )
}
